import { useEffect, useRef } from 'react';
import './App.css';

function App() {
  const ref = useRef(null)

  useEffect(() => {
    if (ref)
    setTimeout(() => {
      ref.current.style.display = 'none'
    }, 2000)
  }, [ref])

  return (
    <div className="App">
      <div className="black" ref={ref} />
      <iframe src="https://artogo.co/zh-TW/exhibition/Ma-Shui-Long-10th-Memorial/space/28860d45aa6b?mode=embed" width="100%" height="100%" title='《看見音樂 聽見畫》' />
    </div>
  );
}

export default App;
